import React from 'react'
import styled from 'styled-components'
import { Text } from '@pancakeswap-libs/uikit'
import { RouteHop } from '../../aggregator'
import { AutoColumn } from '../Column'
import { RowBetween, RowFixed } from '../Row'

const Bar = styled.div`
  display: flex;
  width: 100%;
  height: 6px;
  border-radius: 3px;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.tertiary};
`

const Segment = styled.div<{ share: number; index: number }>`
  width: ${({ share }) => share}%;
  background: ${({ theme, index }) =>
    [theme.colors.primary, theme.colors.secondary, theme.colors.primaryBright, theme.colors.textSubtle][index % 4]};
`

const Legend = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
`

const Swatch = styled.span<{ index: number }>`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  margin-right: 6px;
  background: ${({ theme, index }) =>
    [theme.colors.primary, theme.colors.secondary, theme.colors.primaryBright, theme.colors.textSubtle][index % 4]};
`

/**
 * Where the trade actually goes.
 *
 * The value of routing across sources is invisible unless it is shown, so this
 * renders the split the quote came back with rather than just naming the winner.
 * Renders nothing when there is no split to show.
 */
export default function AggregatorRoute({
  route,
  providerLabel,
  improvementBps,
}: {
  route: RouteHop[]
  providerLabel?: string
  improvementBps?: number
}) {
  if (!route.length) return null

  const total = route.reduce((sum, hop) => sum + hop.portionBps, 0)
  if (total <= 0) return null

  const share = (hop: RouteHop) => (hop.portionBps / total) * 100

  return (
    <AutoColumn gap="8px">
      <RowBetween>
        <Text fontSize="14px" color="textSubtle">
          Route
        </Text>
        {providerLabel && (
          <RowFixed>
            <Text fontSize="14px">
              via {providerLabel}
              {/* Only shown when another source actually competed for this trade. */}
              {improvementBps !== undefined && improvementBps > 0 && (
                <Text as="span" fontSize="14px" color="success">
                  {` +${(improvementBps / 100).toFixed(2)}%`}
                </Text>
              )}
            </Text>
          </RowFixed>
        )}
      </RowBetween>

      <Bar>
        {route.map((hop, index) => (
          <Segment key={hop.source} share={share(hop)} index={index} />
        ))}
      </Bar>

      <Legend>
        {route.map((hop, index) => (
          <Text key={hop.source} fontSize="12px" color="textSubtle">
            <Swatch index={index} />
            {hop.source} {share(hop).toFixed(0)}%
          </Text>
        ))}
      </Legend>
    </AutoColumn>
  )
}
